import React from "react";

export default function Hamburguer() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="22.5" viewBox="0 0 31 22.5">
      <g id="Icons_Line_Hamburger" data-name="Icons / Line / Hamburger" transform="translate(0.5)">
        <rect
          id="Icons_Line_Hamburger_background"
          data-name="Icons / Line / Hamburger background"
          width="30"
          height="22"
          fill="none"
        />
        <path
          id="Line"
          d="M.5.5h29"
          transform="translate(0 1)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          id="Line_Copy"
          data-name="Line Copy"
          d="M.5.5h29"
          transform="translate(0 11)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          id="Line_Copy_2"
          data-name="Line Copy 2"
          d="M.5.5h29"
          transform="translate(0 21)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
